import React, { useRef } from "react";
import { Accordion, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveAuthModalAction,
  toggleSecondaryLeftBarAction,
} from "../redux/app/actions";
import { AuthModals } from "../config/const";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../redux/auth/actions";

import Promotion from "../assets/images/icons/leftbar/clover.png";
import Bonus from "../assets/images/icons/leftbar/referral-bonus.png";
import JetX from "../assets/images/games-icon/jetx-logo.svg";
import Sports from "../assets/images/icons/leftbar/bats.png";
import Cricket from "../assets/images/icons/leftbar/cricket.png";
import LiveCasino from "../assets/images/icons/leftbar/spades.png";
import MiniGames from "../assets/images/icons/leftbar/gamepad.png";
import Lottery from "../assets/images/icons/leftbar/lottery.png";
import TableGames from "../assets/images/icons/leftbar/playing-card.png";
import Slots from "../assets/images/icons/leftbar/slot-machine.png";
import AllGames from "../assets/images/icons/leftbar/king.png";
import Sportsbook from "../assets/images/icons/leftbar/ball.png";

import AppDownload from "../assets/images/icons/leftbar/android.png";
import MobAndroid from "../assets/images/icons/leftbar/mob.png";
import SupportIcon from "../assets/images/icons/leftbar/customer-service.png";
import MyProfile from "../assets/images/icons/leftbar/user.png";
import Mybets from "../assets/images/icons/leftbar/casino-chip.png";
import AccountStatement from "../assets/images/icons/leftbar/taxes.png";
import Referral from "../assets/images/icons/leftbar/follower.png";
import Logout from "../assets/images/icons/leftbar/logout.png";
import CloseBtn from "../assets/images/icons/leftbar/close.png";
import { RouteType, useAppNavigate } from "../hooks/useAppNavigate";
import { useLeftBarHook } from "../hooks/useLeftBarHook";
import { useClickOutside } from "../hooks/useClickOutside";

const SecondaryLeftBar = () => {
  const { appDetails } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const { isAuth } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { user, wallet } = useSelector((state) => state.auth);
  const { appNavigate } = useAppNavigate();
  const leftBarHook = useLeftBarHook();
  const ref = useRef();

  useClickOutside(ref, () => {
    leftBarHook.toggleLeftBar(false);
  });

  return (
    <div className="LeftbarSection" ref={ref}>
      <div className="LeftbarInnerBox">
        <div
          className="CloseBtn"
          role="button"
          onClick={() => leftBarHook.toggleLeftBar(false)}
        >
          <img src={CloseBtn} alt="CloseBtn" />
        </div>
        <div className="LeftbarLogo">
          <img src={appDetails?.LOGO_URL} alt="Logo" />
        </div>

        {!isAuth && (
          <>
            <div className="Login-Registration">
              <Button
                variant="primary"
                onClick={() => {
                  // navigate("/sign-in");
                  dispatch(setActiveAuthModalAction(AuthModals.Login));
                  leftBarHook.toggleLeftBar(false);
                }}
                className="login_btn me-2"
              >
                Login
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  dispatch(setActiveAuthModalAction(AuthModals.Register));
                  leftBarHook.toggleLeftBar(false);
                }}
                className="signup_btn"
              >
                Registration
              </Button>
            </div>
            <div className="LeftbarMenus">
              <ul>
                <li>
                  <div
                    onClick={() => {
                      navigate("/promotion");
                      leftBarHook.toggleLeftBar(false);
                    }}
                    className="menu-option"
                  >
                    <img src={Promotion} alt="Promotion" />
                    <span>Promotion</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      appNavigate("/bonus", RouteType.Protected);
                      leftBarHook.toggleLeftBar(false);
                    }}
                    className="menu-option"
                  >
                    <img src={Bonus} alt="Bonus" />
                    <span>Bonus</span>
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => {
                      navigate("/casino/aggapsmartsoftgaming-jetx");
                      leftBarHook.toggleLeftBar(false);
                    }}
                    className="menu-option jetXImg"
                  >
                    <img src={JetX} alt="Jetx" />
                  </div>
                </li>

                <div className="dividerSection"></div>

                <AllGamesComponent />

                <div className="dividerSection"></div>

                <div className="menu-cards">
                  <div className="menu-card-container">
                    <div className="menu-card-content">
                      <h2>App Download</h2>
                      <div className="menu-card-content__subtitle">
                        <div className="icons-app-download">
                          <img src={AppDownload} aAppDownloadlt="" />
                        </div>
                        <p>Install App.</p>
                      </div>
                    </div>
                    <div className="menu-card-image">
                      <img src={MobAndroid} alt="MobAndroid" />
                    </div>
                  </div>

                  <div className="menu-card-container menu-card-support">
                    <div className="menu-card-content">
                      <h2>Customer Support</h2>
                      <div className="menu-card-content__subtitle">
                        <p>24/7 Online</p>
                      </div>
                    </div>
                    <div className="menu-card-image">
                      <img src={SupportIcon} alt="SupportIcon" />
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </>
        )}

        {isAuth && (
          <>
            <div className="afterlogin-container">
              <div className="member-information-wrapper">
                <div className="member-information">
                  <div className="member-information__account">
                    <div className="account__content-block">
                      <p>User ID</p>
                      <div className="account__content-details">
                        <h3>{user?.mstruserid}</h3>
                      </div>
                    </div>
                  </div>

                  <div className="member-information__account">
                    <div className="account__content-block">
                      <p>Balance</p>
                      <div className="account__content-details">
                        <h3>₹ {wallet?.balance}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="wallet-action-buttons-wrapper">
                <div className="wallet-action-buttons">
                  <div
                    className="button"
                    onClick={() => {
                      navigate("/withdraw");
                      leftBarHook.toggleLeftBar(false);
                    }}
                  >
                    <Button variant="" className="btn_withdraw w-100">
                      Withdraw
                    </Button>
                  </div>
                  <div
                    className="button"
                    onClick={() => {
                      navigate("/gatewaylist");
                      leftBarHook.toggleLeftBar(false);
                    }}
                  >
                    <Button variant="primary" className="btn_primary w-100">
                      Deposit
                    </Button>
                  </div>
                </div>
              </div>

              <div className="LeftbarMenus">
                <ul>
                  <li>
                    <div
                      onClick={() => {
                        navigate("/promotion");
                        leftBarHook.toggleLeftBar(false);
                      }}
                      className="menu-option"
                    >
                      <img src={Promotion} alt="Promotion" />
                      <span>Promotion</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() => {
                        navigate("/bonus");
                        leftBarHook.toggleLeftBar(false);
                      }}
                      className="menu-option"
                    >
                      <img src={Bonus} alt="Bonus" />
                      <span>Bonus</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() => {
                        appNavigate(
                          "/casino/aggapsmartsoftgaming-jetx",
                          RouteType.Protected,
                        );
                        leftBarHook.toggleLeftBar(false);
                      }}
                      className="menu-option jetXImg"
                    >
                      <img src={JetX} alt="Jetx" />
                    </div>
                  </li>

                  <div className="dividerSection"></div>

                  <AllGamesComponent />

                  <div className="dividerSection"></div>

                  <li>
                    <div
                      onClick={() => {
                        navigate("/profile");
                        leftBarHook.toggleLeftBar(false);
                      }}
                      className="menu-option"
                    >
                      <img src={MyProfile} alt="MyProfile" />
                      <span>My Profile</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() => {
                        navigate("/mybets");
                        leftBarHook.toggleLeftBar(false);
                      }}
                      className="menu-option"
                    >
                      <img src={Mybets} alt="Mybets" />
                      <span>My Bets</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() => {
                        navigate("/cashier");
                        leftBarHook.toggleLeftBar(false);
                      }}
                      className="menu-option"
                    >
                      <img src={AccountStatement} alt="AccountStatement" />
                      <span>Account Statement</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() => {
                        navigate("/referral");
                        leftBarHook.toggleLeftBar(false);
                      }}
                      className="menu-option"
                    >
                      <img src={Referral} alt="Referral" />
                      <span>Referral</span>
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() => {
                        leftBarHook.toggleLeftBar(false);
                        dispatch(logoutUser(true));
                      }}
                      className="menu-option"
                    >
                      <img src={Logout} alt="Logout" />
                      <span>Logout</span>
                    </div>
                  </li>
                  <div className="dividerSection"></div>

                  <div className="menu-cards">
                    <div className="menu-card-container">
                      <div className="menu-card-content">
                        <h2>App Download</h2>
                        <div className="menu-card-content__subtitle">
                          <div className="icons-app-download">
                            <img src={AppDownload} aAppDownloadlt="" />
                          </div>
                          <p>Install App.</p>
                        </div>
                      </div>
                      <div className="menu-card-image">
                        <img src={MobAndroid} alt="MobAndroid" />
                      </div>
                    </div>

                    <div className="menu-card-container menu-card-support">
                      <div className="menu-card-content">
                        <h2>Customer Support</h2>
                        <div className="menu-card-content__subtitle">
                          <p>24/7 Online</p>
                        </div>
                      </div>
                      <div className="menu-card-image">
                        <img src={SupportIcon} alt="SupportIcon" />
                      </div>
                    </div>
                  </div>
                </ul>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default SecondaryLeftBar;

const AllGamesComponent = () => {
  const navigate = useNavigate();
  const { appNavigate } = useAppNavigate();
  const leftBarHook = useLeftBarHook();

  return (
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="1">
        <Accordion.Header>
          <h1>
            <img src={AllGames} alt="AllGames" />
            <span>All Games</span>
          </h1>
        </Accordion.Header>
        <Accordion.Body>
          <div className="HomePageInnerContent">
            <ul>
              <li>
                <div
                  onClick={() => {
                    appNavigate("/sportsbook/Inplay", RouteType.Protected);
                    leftBarHook.toggleLeftBar(false);
                  }}
                >
                  <img src={Sports} alt="Sports" />
                  <span>Inplay</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    appNavigate("/sports/ig_pixel", RouteType.Protected);
                  }}
                >
                  <img src={Sportsbook} alt="Sports" />
                  <span>Sportsbook</span>
                </div>
              </li>

              <li>
                <div
                  onClick={() => {
                    appNavigate("/casino-types/casino", RouteType.Protected);
                    leftBarHook.toggleLeftBar(false);
                  }}
                >
                  <img src={LiveCasino} alt="LiveCasino" />
                  <span>Live Casino</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    appNavigate("/casino-types/miniGames", RouteType.Protected);
                    leftBarHook.toggleLeftBar(false);
                  }}
                >
                  <img src={MiniGames} alt="MiniGames" />
                  <span>Mini Games</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    appNavigate(
                      "/casino-types/lotterygames",
                      RouteType.Protected,
                    );
                    leftBarHook.toggleLeftBar(false);
                  }}
                >
                  <img src={Lottery} alt="Lottery" />
                  <span>Lottery</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    appNavigate(
                      "/casino-types/tabelgames",
                      RouteType.Protected,
                    );
                    leftBarHook.toggleLeftBar(false);
                  }}
                >
                  <img src={TableGames} alt="TableGames" />
                  <span>Table Games</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    appNavigate(
                      "/casino-types/slotsgames",
                      RouteType.Protected,
                    );
                    leftBarHook.toggleLeftBar(false);
                  }}
                >
                  <img src={Slots} alt="Slots" />
                  <span>Slots</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/sportsbook/Cricket", RouteType.Protected);
                    leftBarHook.toggleLeftBar(false);
                  }}
                >
                  <img src={Cricket} alt="Cricket" />
                  <span>Cricket</span>
                </div>
              </li>
            </ul>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
